import Message from "../../../middle/message/Message";
import { globalDexieDb } from "../DexiedbLib";
import { IDBMessage } from "../model/dbMessage";
import { ApiResult } from "./localBackend";
import { MessageReport, MessageReportImpl } from "./totalReport";
import { ITotalreportAll, TotalreportAllImpl } from "./totalreportAllType";
// TypeScript Equivalent
interface BalanceReportItem {
    contactId: number;
    name: string;
    mienBac: number;
    mienTrung: number;
    mienNam: number;
    laiLo: number;
}

type BalanceReportData = { [key: string]: BalanceReportItem };

/** bản chất là gọi báo cáo n contact và 3 miền cho mỗi người*/
export async function GetBalanceReportDataLocal(ngay: string): Promise<BalanceReportData> {
    const reportData: BalanceReportData = {};

    const payload = {
        messageId: 0,
        mienDaiCuocId: 1,
        ngay: ngay,
        contactId: 1,
    }
    // xác định danh sách contact;
    const contactIdList: Map<number, string> = new Map();
    (await globalDexieDb.dbmessages.where('date').equals(ngay).toArray()).forEach(item => {
        contactIdList.set(item.contactId, '');
    })
    for (let [key, value] of contactIdList) {
        payload.contactId = key;
        const newItem = {
            contactId: key,
            name: '',
            mienBac: 0,
            mienTrung: 0,
            mienNam: 0,
            laiLo: 0,
        }
        reportData[key] = newItem;
        payload.mienDaiCuocId = 1;// mien bac
        let rpt: MessageReportImpl = new MessageReportImpl();
        await rpt.buildReport(payload) // mien bac
        newItem.mienBac = rpt.laiLoToanBo

        payload.mienDaiCuocId = 2;// mien trung
        rpt = new MessageReportImpl();
        await rpt.buildReport(payload) // mien trung        
        newItem.mienTrung = rpt.laiLoToanBo

        payload.mienDaiCuocId = 3;// mien nam
        rpt = new MessageReportImpl();
        await rpt.buildReport(payload) // mien nam
        newItem.mienNam = rpt.laiLoToanBo

        newItem.laiLo = newItem.mienBac + newItem.mienTrung + newItem.mienNam;
        newItem.name = rpt.contactName;
        reportData[key] = newItem;

    }

    return reportData
}
/**báo cáo lãi lỗ*/
export async function GetTotalReportDataLocal(params: any): Promise<ApiResult> {
    // 1:MB,2:MT,3:MN 0 3 mien
    const { ngay, mienDaiCuocId } = params;


    const payload = {
        messageId: 0,
        mienDaiCuocId: mienDaiCuocId,
        ngay: ngay,
        contactId: 1,
        type: 1,
    }
    const hashMap = new Map<number, IDBMessage>()
    const messages = await globalDexieDb.dbmessages.where('date').equals(ngay).toArray()
    messages.forEach((item: IDBMessage) => {
        hashMap.set(item.contactId, item)
    })
    const result: ITotalreportAll[] = []
    for (let [contactId, msg] of hashMap) {
        const newReport: TotalreportAllImpl = new TotalreportAllImpl()
        newReport.contactId = contactId;

        //
        payload.contactId = contactId;

        payload.type = 1
        payload.mienDaiCuocId = mienDaiCuocId;
        let rpt: MessageReportImpl = new MessageReportImpl();
        let newItemNhan = await rpt.buildReport(payload)

        if (newItemNhan.children.length > 0) {
            newItemNhan.body = `Nhận: ${newItemNhan.contactName}`
            newReport.nhanVe = newItemNhan
        }
        //
        payload.type = 2
        rpt = new MessageReportImpl();
        let newItemChuyen = await rpt.buildReport(payload)

        if (newItemChuyen.children.length > 0) {
            newItemChuyen.body = `Chuyển: ${newItemChuyen.contactName}`
            newReport.chuyenDi = newItemChuyen;
        }
        //
        if (newReport.nhanVe != null)
            newReport.contactName = newReport.nhanVe.contactName;
        else if (newReport.chuyenDi != null)
            newReport.contactName = newReport.chuyenDi.contactName;
        if (newReport.nhanVe || newReport.chuyenDi)
            result.push(newReport)

    }
    const ret: ApiResult = {
        responseText: "Hoàn thành báo cáo",
        errorCode: 0,
        data: result,
        dataEx: null,
    }
    return ret
}
export async function getBalanceReportLocal(payload: { ngay: string }): Promise<ApiResult> {
    const { ngay } = payload
    const result: ApiResult = {
        responseText: 'Hoàn thành lập báo cáo',
        errorCode: 0,
        dataEx: null,
        data: await GetBalanceReportDataLocal(ngay),
    }
    return result
}